// @vendors
const get = require('lodash/object/get');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const translateExantCostKey = require('utilities/translationExantCost');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @actions
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');

// @constants
const actionTypes = require('constants/actionTypes');
const {
    FIRST_STEP,
    SECOND_STEP,
    FOR_THE_BEST_CODE,
    LIMITED_CODE,
    TO_MARKET_CODE,
    EURO_TEXT,
    BROKER_CONVENIENCE_MIFID_TEST_ETF_ID,
    BROKER_CONVENIENCE_MIFID_TEST_ETF_INT_ID,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    BROKER_STOCKS_BUY_NO_RESTRICTION,
    BROKER_ALERT_BUY_BUTTON_ETF,
    API_CHANNEL,
    CHARGE_ACCOUNT_PREFIX,
    INTERVENER_TYPE_PROPIETARIO,
    BROKER_ORDER_TYPE_SELL,
    BROKER_PRODUCT_TYPE_ETFS_ES,
} = require('constants/index');
const { ETFS_SELL_SHOW_COST } = require('constants/flagBasedFeatures');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME } } = require('commonsConstants/dateFormatTypes');

function getCodes() {
    const pathName = window.location.pathname;
    const paramRegex = /(?:[^\/\n]|\/\/)+/g;
    const params = pathName.match(paramRegex);
    const emisionCode = params[params.length - 2];
    const valueCode = params[params.length - 1];

    return {
        emisionCode,
        valueCode
    };
}

function reset() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function stockContractChanged(value, titles) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_STOCK_CONTRACT_CHANGED,
        payload: {
            value,
            titles
        }
    };
}

function validityDateChanged(value) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
}

function orderTypeOptionChanged(value) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_ORDER_TYPE_OPTION_CHANGED,
        payload: {
            value
        }
    };
}

function orderTypeValueChanged(value, sellPrice) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_ORDER_TYPE_VALUE_CHANGED,
        payload: {
            value,
            sellPrice
        }
    };
}

function orderTypeValueReset() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_ORDER_TYPE_VALUE_RESET
    };
}

function titleQuantityChanged(value, manually) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_TITLE_QUANTITY_CHANGED,
        payload: {
            value,
            manually
        }
    };
}

function validateUIStep(step) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_VALIDATE_STEP,
        payload: {
            step
        }
    };
}

function validateWithAPISuccess(response) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_VALIDATE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function validateWithAPIFailure(response) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_VALIDATE_FAILURE,
        payload: {
            data: response
        }
    };
}

function validateWithAPIRequest() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_VALIDATE_REQUEST
    };
}

function etfSellFinish(response) {
    return {
        type: actionTypes.BROKER_ETF_SELL_FINISH,
        payload: {
            data: get(response, 'timestamp', '')
        }
    }
}

function getValidationData(getState) {
    const validationData = {
        descripcionRestriccion: BROKER_STOCKS_BUY_NO_RESTRICTION,
        tipoNegociacion: '0',
        tipoRestriccion: '0'
    };

    const orderTypes = {};

    orderTypes[BROKER_ORDER_TYPE_FOR_THE_BEST] = {
        code: FOR_THE_BEST_CODE,
        orderDescription: BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_LIMITED] = {
        code: LIMITED_CODE,
        orderDescription: BROKER_ORDER_TYPE_LIMITED_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_TO_MARKET] = {
        code: TO_MARKET_CODE,
        orderDescription: BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION
    };

    const operationFirstStep = getState()['brokerETFsSell'].getIn(['steps', FIRST_STEP]);
    const orderType = operationFirstStep.get('orderTypeOption');
    const validityDate = operationFirstStep.get('validityDate');
    const titleQuantity = operationFirstStep.get('titleQuantity');

    validationData['importeAprximado'] = {
        divisa: EURO_TEXT,
        importe: 0
    };

    const currency = getState().brokerProductFile.get('currency');

    if (orderType === BROKER_ORDER_TYPE_LIMITED) {
        validationData['importeLimitada'] = {
            divisa: currency,
            numeroimportevalores: operationFirstStep.get('orderTypeValue')
        };
    } else {
        validationData['importeLimitada'] = {
            divisa: currency,
            numeroimportevalores: 0
        };
    }
    validationData['numTitulos'] = titleQuantity;
    validationData['tipoOrden'] = orderTypes[orderType].code;
    validationData['descripcionOrden'] = orderTypes[orderType].orderDescription;
    validationData['plazoValidez'] = validityDate.format('YYYY-MM-DD');

    return validationData;
}

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    };
}

const getHolders = (contract, interveners) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter((intervener) => {
            return intervener.get('tipoIntervencion').trim() === INTERVENER_TYPE_PROPIETARIO
        });
        holderNames = holders.map(holder => {
            return holder.get('nomInterviniente').trim()
        });
    } else {
        const holder = contract.get('walletTitular');
        holderNames.push(holder)
    }
    return holderNames;
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
            ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
            : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

function sendOrderSummaryRequest() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_SEND_ORDER_SUMMARY_REQUEST,
    };
}
function sendOrderSummarySuccess() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_SEND_ORDER_SUMMARY_SUCCESS,
    };
}
function sendOrderSummaryError() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_SEND_ORDER_SUMMARY_ERROR,
    };
}


const sendOrderSummary = (response) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immBrokerETFsSell = getState().brokerETFsSell;
    const dataValidation = getValidationData(getState);
    const selectedOption = immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });
    const contractNumber = contract.get('walletNumber');
    const productNumber = contract.get('productNumber');
    const controlDigit = contract.get('controlDigit');
    const securityAccount = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;
    const operationFirstStep = getState()['brokerETFsSell'].getIn(['steps', FIRST_STEP]);
    const shareNumber = dataValidation.numTitulos;
    const typeOrder = immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'orderTypeOption']);
    const sharesAmount = !!immBrokerETFsSell.get("estimatedBaseAmount")
        ? immBrokerETFsSell.getIn(["estimatedBaseAmount", "amount"])
        : !!dataValidation.importeAprximado
            ? dataValidation.importeAprximado.importe
            : 0;
    const marketName = getState().brokerProductFile.get('marketName');
    const emittedDateTime = momentTz(parseInt(get(response, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const interveners = getState().brokerInterveners.get('list');
    const holderNames = getHolders(contract, interveners);
    let conditionPrice = 0
    if (typeOrder === BROKER_ORDER_TYPE_LIMITED) {
        conditionPrice = "" + immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'orderTypeValue'])
    } else {
        conditionPrice = operationFirstStep.get('orderTypeLimited') ? operationFirstStep.get('orderTypeLimited') : '';
    }

    const exAnteData = !!immBrokerETFsSell.get("exAnteData")
        ? translateExantCostKey(
            immBrokerETFsSell.get("exAnteData").toJS(),
            "brokerETFsSell"
        ) : null;
    const communicationServiceInput = {
        "email": PersonalDataHelper.getEmail(immProfile),
        "productKID": "",
        "contract": "",
        "marketingReport": "",
        "infoCcv": "",
        "sendOrder": "No",
        "ccc": get(response, ['datosCuentaAsociada', 'codIban', 'codbban'], '').trim(),
        "ccv": securityAccount,
        "idContract": securityAccount,
        "conditionPrize": "" + conditionPrice + "",
        "currency": get(response, ['datosCuentaAsociada', 'saldoCuentaAsociada', 'divisa'], ''),
        "holders": holderNames.join(','),
        "idOrder": get(response, 'numeroOrden', ''),
        "isin": getState().brokerProductFile.get('isinCode'),
        "isinDescribe": getState().brokerProductFile.get('companyName'),
        "market": marketName,
        "orderCondition": dataValidation.descripcionOrden,
        "orderType": BROKER_ORDER_TYPE_SELL,
        "productType": BROKER_PRODUCT_TYPE_ETFS_ES,
        "sharesAmount": sharesAmount,
        "sharesNumber": "" + shareNumber + "",
        "termValidity": dataValidation.plazoValidez,
        "clientAlias": immProfile.get('nombreCliente'),
        "channel": __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime": emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
        "exAnteCostsList": exAnteData,
    };

    const data = {
        query: communicationServiceInput
    };

    dispatch(sendOrderSummaryRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), data).then(
        function () {
            dispatch(sendOrderSummarySuccess());
        },
        function () {
            dispatch(sendOrderSummaryError());
        }
    );
}

function confirmETFsSellSuccess(response) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_CONFIRM_SUCCESS,
        payload: {
            data: response
        }
    };
}

function confirmETFsSellFailure(response) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

function confirmETFsSellRequest() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_CONFIRM_REQUEST
    };
}

const confirmETFsSell = (history) => (dispatch, getState) => {
    const ETFsSellState = getState().brokerETFsSell;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immETFsSellStep1 = ETFsSellState.getIn(['steps', FIRST_STEP]);
    const valid = ETFsSellState.getIn(['steps', SECOND_STEP, 'valid']);
    const dataToken = ETFsSellState.get('token');
    const confirmationData = ETFsSellState.get('confirmationData');
    const executionData = confirmationData.datosEjecucion;
    const selectedContractValue = immETFsSellStep1.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedContractValue;
    });
    if (!contract) {
        return;
    }

    const codes = getCodes();
    const immBrokerProductFile = getState().brokerProductFile;
    const isinCode = immBrokerProductFile.get('isinCode');
    const micCode = immBrokerProductFile.get('micCode');
    const isSpain = isinCode.substr(0, 2).toLowerCase() === 'es';
    const productId = immBrokerProductFile.get('isComplex') ? BROKER_CONVENIENCE_MIFID_TEST_ETF_INT_ID : BROKER_CONVENIENCE_MIFID_TEST_ETF_ID;
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', productId, 'codigoDisclaimer']);
    const shares = immETFsSellStep1.get('titleQuantity');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const data = {
        contratoValores: {
            numerodecontrato: contract.get('walletNumber'),
            producto: contract.get('productNumber')
        },
        dataToken: dataToken,
        datosEjecucion: {
            codigoGrupoSector: executionData.codigoGrupoSector,
            codigoOrganismoEjecucion: executionData.codigoOrganismoEjecucion,
            codigoValorJuntSind: executionData.codigoValorJuntSind,
            codvalorSib: executionData.codvalorSib,
            indicadorCompensacion: executionData.indicadorCompensacion,
            indicadorContingencia: executionData.indicadorContingencia,
            indicadorEnvioRecepcion: executionData.indicadorEnvioRecepcion,
            nominalTitulo: {
                divisa: executionData.nominalTitulo.divisa,
                importe: executionData.nominalTitulo.importe
            },
            tipoCotizacion: executionData.tipoCotizacion,
            tipoMercado: executionData.tipoMercado,
            tipoOperacion: 'V',
            titulosNominalMinEjec: 0,
            tratamientoEmision: executionData.tratamientoEmision
        },
        datosEmision: {
            codEmision: codes.emisionCode,
            codMercado: confirmationData.codMercado,
            codValor: codes.valueCode
        },
        datosValidacion: getValidationData(getState),
        "convenienceTest": codigoDisclaimer,
        "productIsin": isinCode,
        "productType": BROKER_ALERT_BUY_BUTTON_ETF,
        "shares": shares,
        "initQuantity": shares,
        "unitPrice": immBrokerProductFile.get('lastClose'),
        "micCode": micCode,
        "productManager": immBrokerProductFile.get('manager'),
        "disclaimers": {
            "disclaimer_1": "",
            "disclaimer_2": "",
            "disclaimer_3": "",
            "disclaimer_4": "",
            "disclaimer_5": ""
        },
        "convenientRegistry": false,
        "evaluateRegistry": false,
        "marketTargetRegistry": false,
        "necessaryConvenienceTestNote": 0,
        "necessaryTargetMarketNote": "",
        "testConveniencyResult": 0,
        "documentationId": uuid
    };

    if (isSpain) {
        data.datosEjecucion['codigoBolsa'] = '1';
    }

    const requestData = {
        header: {
            version: 2
        },
        query: data
    };

    if (valid) {
        dispatch(confirmETFsSellRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('confirmStocksBuySell'), requestData).then(
            function (response) {
                if (immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST)) {
                    dispatch(sendOrderSummary(response));
                }
                dispatch(confirmETFsSellSuccess(response));
                dispatch(etfSellFinish(response));
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function (response) {
                dispatch(confirmETFsSellFailure(response));
                dispatch(brokerStocksOperationFailure(response, history));
            }
        );
    }
};

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(signaturePatternSuccess(dataToken));
        dispatch(confirmETFsSell(history));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};


const validateWithAPI = (history) => (dispatch, getState) => {
    let requestData, data;
    const immETFsSellStep1 = getState().brokerETFsSell.getIn(['steps', FIRST_STEP]);
    const valid = immETFsSellStep1.get('valid');
    const validSecondStep = getState()['brokerETFsSell'].getIn(['steps', SECOND_STEP, 'valid']);

    if (valid && validSecondStep) {
        dispatch(finish(history));
        return;
    } else if (!valid || validSecondStep) {
        return;
    }

    const selectedOption = immETFsSellStep1.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });

    if (!contract) {
        return;
    }

    const contractNumber = contract.get('walletNumber');
    const codes = getCodes();
    const controlDigit = getState().brokerStocksContract
        .find(wallet => wallet.get('walletNumber') === contractNumber)
        .get('controlDigit');
    requestData = {
        codEmision: codes.emisionCode,
        codValor: codes.valueCode,
        contratoValores: {
            numerodecontrato: contractNumber,
            producto: contract.get('productNumber')
        },
        datosValidacion: getValidationData(getState),
        digitoControl: controlDigit,
        tipoOperacion: 'V'
    };

    data = {
        query: requestData
    };

    dispatch(validateWithAPIRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('sellStocks'), data).then(
        function (response) {
            dispatch(validateWithAPISuccess(response));
        },
        function (response) {
            dispatch(validateWithAPIFailure(response));
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        }
    );
};

const validateStep = (step, history) => dispatch => {
    dispatch(validateUIStep(step));
    dispatch(validateWithAPI(history));
};

function getExAnteDataSuccess(response) {
    return {
        type: actionTypes.BROKER_ETFS_SELL_EX_ANTE_SUCCESS,
        payload: {
            data: response
        }
    };
}
function getExAnteDataFailure() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_EX_ANTE_FAILURE,
    };
}
function getExAnteDataFetching() {
    return {
        type: actionTypes.BROKER_ETFS_SELL_EX_ANTE_FETCHING,
    };
}

const getExAnteData = (history) => (dispatch, getState) => {
    const immETFsSellStep1 = getState().brokerETFsSell.getIn(['steps', FIRST_STEP]);
    const immBrokerProductFile = getState().brokerProductFile;
    const selectedOption = immETFsSellStep1.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });
    const contractNumber = contract.get('walletNumber');
    const isinCode = immBrokerProductFile.get('isinCode');
    const shares = immETFsSellStep1.get('titleQuantity');
    const orderTypeOption = immETFsSellStep1.get('orderTypeOption');
    const productCurrency = immBrokerProductFile.get('currency');
    let limitedPrice, orderType;
    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_TO_MARKET:
            limitedPrice = null;
            orderType = "MARKET";
            break;
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            limitedPrice = null;
            orderType = "BEST";
            break;
        case BROKER_ORDER_TYPE_LIMITED:
        default:
            limitedPrice = {
                amount: immETFsSellStep1.get("orderTypeValue"),
                currency: productCurrency,
            }
            orderType = "LIMITED";
            break;
    }
    const requestData = {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contract: {
            number: contractNumber,
            product: contract.get('productNumber'),
        },
        instrumentType: 'ETF',
        isin: isinCode,
        limitedPrice: limitedPrice,
        market: immBrokerProductFile.get('micCode'),
        operationType: 'V',
        orderType: orderType,
        sharesAmount: null,
        sharesNumber: shares,
    };

    const data = {
        query: requestData
    }

    dispatch(getExAnteDataFetching());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), data)
        .then(response => dispatch(getExAnteDataSuccess(response)))
        .catch(() => {
            dispatch(getExAnteDataFailure())
            dispatch(errorActions.show(null, true, history));
        })
}


module.exports = {
    reset,
    setVisibleStep,

    validateStep,

    setWillCancel,
    stockContractChanged,
    validityDateChanged,
    titleQuantityChanged,
    orderTypeOptionChanged,
    orderTypeValueChanged,
    orderTypeValueReset,
    finish,

    getExAnteData
};
